export const notesMixin = {
  computed: {
    filteredNotes() {
      return this.notes
        .replace(new RegExp("<script>", "gi"), "&lt;script&gt;")
        .replace(new RegExp("<//script>", "gi"), "&lt;/script&gt;")
        .replace(/(<[^>]+) style=".*?"/gi, "$1")
        .replace(/(<[^>]+) width=".*?"/gi, "$1")
        .replace(/(<[^>]+) height=".*?"/gi, "$1")
        .replace(/(<[^>]+) dir=".*?"/gi, "$1")
        .replace(/(<[^>]+) colspan=".*?"/gi, "$1")
        .replace(/(<[^>]+) rowspan=".*?"/gi, "$1")
        .replace(/(<[^>]+) border=".*?"/gi, "$1")
        .replace(/(<[^>]+) cellspacing=".*?"/gi, "$1")
        .replace(/(<[^>]+) cellpadding=".*?"/gi, "$1")
        .replace(/(<[^>]+) nowrap=".*?"/gi, "$1")
        .replace(/(<[^>]+) bgcolor=".*?"/gi, "$1")
        .replace(/(<[^>]+) rows=".*?"/gi, "$1")
        .replace(/(<[^>]+) cols=".*?"/gi, "$1");
    }
  },
  mounted() {
    this.$refs.editableDiv.innerHTML = this.filteredNotes;
  }
};
